import Vue from "vue";
import Vuex from "vuex";
import RPC from "./rpc";

Vue.use(Vuex);

const server = "https://www.abrajasmt.com.br";

const holder = {
  namespaced: true,
  state: {
    name: "Abrajas",
    social: [
      {
        link: "https://goo.gl/maps/pmsMvCMG99Fqf72L8",
        title:
          "Escritório Operacional: Av. das Sibipirunas, 3813 - Centro - Sinop - MT",
        icon: "fas fa-map-marker-alt",
      },
      {
        link: "https://goo.gl/maps/pmsMvCMG99Fqf72L8",
        title:
          "Escritório Comercial: Av. do Comércio, 615 - Centro - Santa Carmen - MT",
        icon: "fas fa-map-marker-alt",
      },
      {
        link: "mailto:abrajasmt@hotmail.com",
        title: "abrajas@hotmail.com",
        icon: "fas fa-envelope",
      },
      {
        link: "https://www.facebook.com/abrajasmt/",
        title: "Facebook @abrajasmt",
        icon: "fab fa-facebook-f",
      },
      // {
      //   link: 'https://www.linkedin.com/company/abrajasmt/',
      //   title: 'company/abrajasmt',
      //   icon: 'fab fa-linkedin'
      // },
      // {
      //   link: '',
      //   title: 'Youtube',
      //   icon: 'fab fa-youtube'
      // },
      {
        link: "https://www.instagram.com/abrajasmt/",
        title: "Instagram @abrajasmt",
        icon: "fab fa-instagram",
      },
      {
        link: "tel:+5566996302096",
        title: "(66) 99630-2096",
        icon: "fas fa-mobile-alt",
      },
      // {
      //   link: 'tel:+556635320044',
      //   title: '(66) 3532-0044',
      //   icon: 'fas fa-phone'
      // }
    ],
    map:
      "https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d499999.87265395036!2d-55.15720869095029!3d-11.747500385202342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x9309d3e348213301%3A0x3b59e96dfe7bd9cb!2sMT%20140%2C%20Santa%20Carmem%20-%20MT%2C%2078545-000!3m2!1d-12.0247225!2d-55.2761071!4m5!1s0x9308c34edb7bf0db%3A0x249e5ae7bd28903a!2sUni%C3%A3o%20do%20Sul%2C%20State%20of%20Mato%20Grosso!3m2!1d-11.5311919!2d-54.3621118!5e0!3m2!1sen!2sbr!4v1596117148833!5m2!1sen!2sbr",
  },
};

export default new Vuex.Store({
  state: {
    files: server,
    server: server,
    articles: [],
    photos: [],
    about: {},
    nutrology: {},
    treatments: [],
    slides: [],
    partners: [],
    direction: [],
    download: [],
    cotacoes: [],
    project: [],
    videos: [],
  },
  ...RPC(server, {
    getAllArticles: "articles",
    getAllPhotos: "photos",
    getAbout: "about",
    getNutrology: "nutrology",
    getAllSlides: "slides",
    getAllTreatments: "treatments",
    getAllVideos: "videos",
    getAllDownload: "download",
    getAllCotacoes: "cotacoes",
    getAllPartners: "partners",
    getAllDirection: "direction",
    getProject: "project",
  }),
  modules: {
    holder,
  },
});
